import { SideId } from '@wareena/grid-battles-entity/game/codebook/side';
export function createPlayerInfo(game, userId) {
    const playerA = game.players.find((p) => p.side === SideId.A);
    const playerB = game.players.find((p) => p.side === SideId.B);
    const activeSide = game.state.activeSide;
    const activePlayer = activeSide === SideId.A ? playerA : playerB;
    const isCurrentUserPlayerActive = activePlayer.id === userId;
    const currentUserPlayerSide = isCurrentUserPlayerActive ? activeSide : oppositeSide(activeSide);
    const currentUserPlayer = game.players.find((p) => p.side === currentUserPlayerSide);
    const opponentSide = oppositeSide(currentUserPlayerSide);
    const opponentPlayer = game.players.find((p) => p.side === opponentSide);
    return {
        playerA,
        playerB,
        activeSide,
        activePlayer,
        isCurrentUserPlayerActive,
        currentUserPlayerSide,
        currentUserPlayer,
        opponentSide,
        opponentPlayer,
    };
}
function oppositeSide(side) {
    return side === SideId.A ? SideId.B : SideId.A;
}
